<template>
  <div :class="this.visible?'show':''" class="modal fade" tabindex="-1" role="dialog"
       aria-labelledby="exampleModalLabel"
       aria-hidden="true">
    <div class="progressCircular">
      <div class="spinner-border text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: "Loading",
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },
  watch: {
    isLoading(val) {
      console.log('isLoading :', this.visible)
      this.visible = val;
    },
  },
}
</script>

<style scoped>
.show {
  display: block;
}

.modal {
  z-index: 2000;
}

.progressCircular {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.spinner-border {
  width: 100%;
  height: 100%;
}
</style>
